import { Plane, BedDouble, TreePalm, FileCheck2, Car, Ship, Bus, TrainFront, Ticket, Map, Globe, Camera } from "lucide-react";

export const SERVICE_ICONS = {
  plane: Plane, hotel: BedDouble, palm: TreePalm, visa: FileCheck2, car: Car, ship: Ship,
  bus: Bus, train: TrainFront, ticket: Ticket, map: Map, globe: Globe, camera: Camera,
};
export const serviceIcon = (name) => SERVICE_ICONS[name] || Globe;
